export default "__VITE_ASSET__2f14f92f__"